import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import TrainingQuarterlyReportTabs from './TrainingQuarterlyReportTabs';
import { generateUuid } from '@aims/shared/shared/utils';
import CSPage from '../../../components/CSPage';
import CSPageHeader from '../../../components/CSPageHeader';

function TrainingQuarterlyReportsPage() {
  const newReportId = useMemo(() => {
    return generateUuid();
  }, []);
  return (
    <>
      <CSPage
        containerStyle={{ maxWidth: 'unset' }}
        title="Training Quarterly Reports"
      >
        <CSPageHeader
          title="Training Quarterly Reports"
          topActions={[
            <Link
              key="add"
              to={{
                pathname: `/training-quarterly-reports/edit/${newReportId}`,
                state: {
                  mode: 'create',
                },
              }}
            >
              <Button type="link" icon={<PlusCircleOutlined />} size="large">
                Create a Training Quarterly Report
              </Button>
            </Link>,
          ]}
        />
        <TrainingQuarterlyReportTabs />
      </CSPage>
      <style jsx>{``}</style>
    </>
  );
}

export default TrainingQuarterlyReportsPage;
